// extracted by mini-css-extract-plugin
module.exports = {"player-icon-mask":"eF","playerIconMask":"eF","player-icon-box":"eG","playerIconBox":"eG"};